import { render, staticRenderFns } from "./TemplatesEditor.vue?vue&type=template&id=50f2b644&"
import script from "./TemplatesEditor.vue?vue&type=script&lang=js&"
export * from "./TemplatesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports